import React from 'react';
import { SalvCard } from '@salvapp/ui-components';
import BulkRiskOverrideForm from './BulkRiskOverrideForm';
import SalvPage from '../../common/SalvPage';

const BulkRiskOverride = () => {
  return (
    <SalvPage title={'Bulk Risk Override'} className='bulk-risk-override'>
      <SalvCard>
        <SalvCard.Header>Bulk risk override for persons</SalvCard.Header>
        <SalvCard.Body>
          <BulkRiskOverrideForm />
        </SalvCard.Body>
      </SalvCard>
    </SalvPage>
  );
};

export default BulkRiskOverride;
